/**
 * BIL-10 — JoFotara (the ISTD national e-invoicing platform) vocabulary shared
 * by the API and the settings screen. Ported from the production-tested
 * blue-crystal integration; the values are the government's, not ours.
 */

/**
 * The 3rd digit of the UBL InvoiceTypeCode `name` attribute:
 * income = 1 (not registered for sales tax), general_sales = 2 (VAT
 * registered), special_sales = 3.
 */
export const JOFOTARA_TAXPAYER_TYPES = ['income', 'general_sales', 'special_sales'] as const;
export type JofotaraTaxpayerType = (typeof JOFOTARA_TAXPAYER_TYPES)[number];

/** ISO 3166-2:JO — the 12 governorate codes JoFotara accepts. */
export const JO_CITY_CODES: readonly (readonly [string, string])[] = [
  ['JO-AM', 'عمّان'],
  ['JO-AJ', 'عجلون'],
  ['JO-AQ', 'العقبة'],
  ['JO-AT', 'الطفيلة'],
  ['JO-AZ', 'الزرقاء'],
  ['JO-BA', 'البلقاء'],
  ['JO-IR', 'إربد'],
  ['JO-JA', 'جرش'],
  ['JO-KA', 'الكرك'],
  ['JO-MA', 'المفرق'],
  ['JO-MD', 'مأدبا'],
  ['JO-MN', 'معان'],
] as const;

export const JO_CITY_CODE_VALUES: readonly string[] = JO_CITY_CODES.map(([code]) => code);

/** Sanity ceiling for the settings screen — Jordan's GST has never been near it. */
export const JOFOTARA_MAX_TAX_RATE = 26;
